import { useMediaQuery } from "@material-ui/core"

/**
 * 헤더 메뉴가 햄버거 버튼이면 DESKTOP 이 아닌걸로 간주함.
 * 헤더에 메뉴가 많아서 현재를 감당 할 수 있는 width인 850으로 지정했고, 메뉴가 줄어들면 사이즈를 줄여도 무방
 */
export const DESKTOP_VIEW_WIDTH = 768
export default function usePlatform() {
  /** 최초 렌더링시 값이 부정확함.
   * usePlatform 을 쓰는쪽에서
   * useEffect(() => {
   *   if (isDesktop) {
   *     // 이렇게 쓰면 원하는대로 동작하지 않음.
   *     // 그래서 아래 일반 함수를 만들어둠.
   *   }
   * }[]) **/
  const isDesktop = useMediaQuery(`(min-width: ${DESKTOP_VIEW_WIDTH}px)`)
  const isMobile = !isDesktop
  return {
    isDesktop,
    isMobile,
  }
}

export function isDesktop() {
  return window.innerWidth >= DESKTOP_VIEW_WIDTH
}
